export const TOKEN_TYPE_CONFIRM_EMAIL = "CONFIRM_EMAIL";
export const TOKEN_TYPE_CREATE_USER = "CREATE_USER";
export const TOKEN_TYPE_RESET_PASSWORD = "RESET_PASSWORD";
export const TOKEN_TYPE_ADMIN_INVITATION = "ADMIN_INVITATION";

export const TOKEN_STATUS_INVALID = "INVALID";
export const TOKEN_STATUS_USER_CONFIRMED = "CONFIRMED";
export const TOKEN_STATUS_VALID = "VALID";
